<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />
    <div class="header-search">
      <el-form inline :model="searchData">
        <el-form-item label="模版名称">
          <el-input
            v-model.trim="searchData.templateName"
            size="small"
            placeholder="请输入"
            class="search-form-item"
          />
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="handleSearch"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="handleReset"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="page-toolbar">
      <el-button type="primary" size="small" @click="handleCreate">
        新增模板
      </el-button>
    </div>

    <el-row :gutter="16" class="card-list" v-loading="tableLoading">
      <el-col
        v-for="item in pageList"
        :key="item.id"
        :span="6"
        class="card-list-item"
      >
        <el-card shadow="hover" class="template-card">
          <div class="card-head">
            <span class="card-title">方案列表</span>
            <el-tag
              size="medium"
              type="primary"
              class="default-tag"
              v-if="item.isDefault"
            >
              默认
            </el-tag>
          </div>

          <div class="card-body">
            <div
              v-for="(plan, idx) in item.planList"
              :key="`${item.id}-${idx}`"
              class="plan-item"
            >
              <span class="plan-name">{{ plan.comboName }}</span>
              <span v-if="plan.comboTypeLabel" class="plan-type">（{{ plan.comboTypeLabel }}）</span>
            </div>
          </div>

          <div class="card-footer">
            <div class="template-name">
              {{ item.templateName }}
              <i class="el-icon-edit-outline action-icon" @click="handleRename(item)" />
            </div>
            <div class="card-actions">
              <el-link
                :underline="false"
                type="primary"
                v-if="!item.isDefault"
                @click="handleSetDefault(item)"
              >
                设为默认
              </el-link>
              <el-link :underline="false" type="primary" @click="handleOpenEditDialog(item)">
                编辑模板
              </el-link>
              <!-- <el-link :underline="false" type="primary" @click="handleRename(item)">
                重命名模板
              </el-link> -->
              <el-link :underline="false" type="primary" @click="handleDetail(item)">
                查看详情
              </el-link>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="table.currentPage"
        :page-size="table.pageSize"
        :total="table.total"
      />
    </div>

    <el-dialog
      :title="templateDialog.mode === 'create' ? '新增模板' : '重命名模板'"
      :visible.sync="templateDialog.visible"
      width="500px"
      @close="resetTemplateDialog"
    >
      <el-form
        ref="templateForm"
        :model="templateDialog.form"
        :rules="templateDialogRules"
        label-width="90px"
      >
        <el-form-item label="模板名称" prop="templateName">
          <el-input
            v-model.trim="templateDialog.form.templateName"
            size="small"
            maxlength="30"
            placeholder="请输入"
            class="search-form-item"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="templateDialog.visible = false">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmitTemplate">提交</el-button>
      </span>
    </el-dialog>

    <template-plan-dialog
      :visible.sync="editDialog.visible"
      :title="'编辑模版'"
      mode="edit"
      :selected-ids="editDialog.selectedIds"
      @submit="onSubmitEditDialog"
    />

    <template-plan-dialog
      :visible.sync="detailDialog.visible"
      :title="'模版详情'"
      mode="detail"
      :template-id="detailDialog.templateId"
    />
  </div>
</template>

<script>
import TemplatePlanDialog from "./components/template-plan-dialog.vue";
import { ComboTypeToTextMap } from "@/enum/dict/index.js";
import {
  getComboTemplatePage,
  addComboTemplate,
  editComboTemplate,
  editComboTemplateDefault,
  bindComboTemplate,
} from "./api.js";

export default {
  name: "StoreComboTemplateList",
  components: {
    TemplatePlanDialog,
  },
  data() {
    return {
      searchData: {
        templateName: "",
      },
      table: {
        currentPage: 1,
        pageSize: 12,
        total: 0,
      },
      tableLoading: false,
      pageList: [],
      templateDialog: {
        visible: false,
        mode: "create",
        editId: null,
        form: {
          templateName: "",
        },
      },
      templateDialogRules: {
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
      },
      editDialog: {
        visible: false,
        templateId: null,
        selectedIds: [],
      },
      detailDialog: {
        visible: false,
        templateId: null,
      },
    };
  },
  watch: {
    "table.currentPage"() {
      this.getList();
    },
    "table.pageSize"() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    mapTemplateItem(item) {
      const comboList = item.comboList || [];
      const selectedIds = comboList.map((combo) => combo.id);
      const planList = comboList
        .filter((combo) => combo.comboName)
        .map((combo) => ({
          comboName: combo.comboName,
          comboTypeLabel: ComboTypeToTextMap.get(combo.comboType) || "",
        }));
      return {
        id: item.id,
        templateName: item.tplName || "",
        isDefault: !!item.isDefault,
        selectedIds,
        planList,
      };
    },
    async getList() {
      this.tableLoading = true;
      try {
        const res = await getComboTemplatePage({
          page: this.table.currentPage,
          pageSize: this.table.pageSize,
          tplName: this.searchData.templateName || undefined,
        });
        const list = (res.list || []).map(this.mapTemplateItem);
        this.pageList = list;
        this.table.total = res.total || 0;
      } finally {
        this.tableLoading = false;
      }
    },
    applySearch(resetPage = false) {
      if (resetPage && this.table.currentPage !== 1) {
        this.table.currentPage = 1;
        return;
      }
      this.getList();
    },
    handleSearch() {
      this.applySearch(true);
    },
    handleReset() {
      this.searchData.templateName = "";
      this.applySearch(true);
    },
    handleCreate() {
      this.templateDialog.mode = "create";
      this.templateDialog.editId = null;
      this.templateDialog.visible = true;
      this.$nextTick(() => {
        this.$refs.templateForm?.clearValidate();
      });
    },
    async handleSetDefault(item) {
      await editComboTemplateDefault({
        id: item.id,
      });
      this.getList();
      this.$message.success("已设为默认");
    },
    handleRename(item) {
      this.templateDialog.mode = "rename";
      this.templateDialog.editId = item.id;
      this.templateDialog.form.templateName = item.templateName;
      this.templateDialog.visible = true;
      this.$nextTick(() => {
        this.$refs.templateForm?.clearValidate();
      });
    },
    handleOpenEditDialog(item) {
      this.editDialog.visible = true;
      this.editDialog.templateId = item.id;
      this.editDialog.selectedIds = [...(item.selectedIds || [])];
    },
    async onSubmitEditDialog(selectedIds) {
      await bindComboTemplate({
        id: this.editDialog.templateId,
        comboIdList: selectedIds,
      });
      this.editDialog.visible = false;
      this.$message.success("保存成功");
      this.getList();
    },
    handleDetail(item) {
      this.detailDialog.templateId = item.id;
      this.detailDialog.visible = true;
    },
    onSubmitTemplate() {
      this.$refs.templateForm.validate(async (valid) => {
        if (!valid) {
          return;
        }

        const templateName = this.templateDialog.form.templateName.trim();
        if (this.templateDialog.mode === "create") {
          await addComboTemplate({
            tplName: templateName,
          });
          this.$message.success("新增成功");
        } else {
          await editComboTemplate({
            id: this.templateDialog.editId,
            tplName: templateName,
          });
          this.$message.success("重命名成功");
        }

        this.templateDialog.visible = false;
        this.applySearch(true);
      });
    },
    resetTemplateDialog() {
      this.templateDialog.form.templateName = "";
      this.templateDialog.mode = "create";
      this.templateDialog.editId = null;
      this.$refs.templateForm?.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-form-item {
  width: 220px;
}

.page-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.card-list-item {
  margin-bottom: 16px;
}

.template-card {
  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 24px;
    margin-bottom: 10px;

    .card-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }

    .default-tag {
      font-size: 13px;
      font-weight: 600;
      padding: 0 10px;
      height: 24px;
      line-height: 22px;
      border-radius: 6px;
    }
  }

  .card-body {
    height: 140px;
    border: 1px solid #ebeef5;
    padding: 8px 10px;
    margin-bottom: 10px;
    overflow-y: auto;

    .plan-item {
      line-height: 28px;
      color: #606266;
      border-bottom: 1px dashed #ebeef5;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .plan-type {
        color: #909399;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .card-footer {
    .template-name {
      display: flex;
      align-items: center;
      color: #303133;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .action-icon {
      margin-left: 8px;
      cursor: pointer;
      color: #409eff;
    }

    .card-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
